export default __webpack_public_path__ + "dc94c7470d0d3d37faa4783866400dce.png";